<span class="created-by">
  <b><a href="http://kasoft.vn/" target="_blank">KaSoft</a></b> ♥ Giải pháp
  chuyển đổi số
</span>
<div class="socials" [nbSpinner]="loading" nbSpinnerStatus="info">
  <!-- <a href="#" target="_blank" class="ion ion-social-github"></a>
  <a href="#" target="_blank" class="ion ion-social-facebook"></a>
  <a href="#" target="_blank" class="ion ion-social-twitter"></a>
  <a href="#" target="_blank" class="ion ion-social-linkedin"></a> -->

  <button
    nbButton
    ghost
    shape="round"
    status="primary"
    size="small"
    [disabled]="loading"
    [class.btn-pulse]="loading"
    [nbContextMenu]="menuItems"
  >
    <nb-icon icon="sync-outline"></nb-icon>
    <span>Đồng bộ</span>
  </button>
</div>
